import { Theme, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
import { CustomTypography } from 'shared/elements/CustomTypography';

export const ProjectDetailsCont = styled('div')(({ theme }) => ({
  padding: '15px 15px 0 15px',
  display: 'flex',
  flexDirection: 'column',
  '& .MuiTypography-root': {
    fontSize: 12,
  },
  gap: 15,
}));

export const MediaSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
  flex: 1,
}));

export const DetailsLayout = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 25,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const MediaCont = styled('div')(({ theme }) => ({
  paddingRight: 10,
  gap: 10,
  display: 'flex',
  flexWrap: 'wrap',
  maxHeight: 300,
  overflow: 'auto',
}));

export const DetailsItem = styled('div')<Theme, { bordered?: number; maxwidth?: number; left?: number }>(
  ({ theme, bordered, maxwidth, left }) => ({
    ...(left && { marginLeft: 'auto' }),
    display: 'flex',
    flexDirection: 'column',
    ...(bordered && { paddingLeft: 15 }),
    borderLeft: bordered
      ? `1px solid ${theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER}`
      : 'none',
    ...(maxwidth && { maxWidth: maxwidth }),
    // maxHeight: 'fit-content',
    // height: 'fit-content',
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      borderLeft: 'none',
      maxWidth: 'unset',
      paddingLeft: 0,
      marginLeft: 0,
    },
  }),
);

export const DetailsLabel = styled(CustomTypography)(({ theme }) => ({
  color: COLORS.MAIN_GRAY,
}));

export const DetailsText = styled(CustomTypography)(({ theme }) => ({
  whiteSpace: 'pre-wrap',
}));
